import { render, staticRenderFns } from "./group-criteria-form.vue?vue&type=template&id=d523e21e"
import script from "./group-criteria-form.vue?vue&type=script&lang=js"
export * from "./group-criteria-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports